import { render, staticRenderFns } from "./fullscreen-layout.vue?vue&type=template&id=70bb0732&scoped=true&"
import script from "./fullscreen-layout.vue?vue&type=script&lang=js&"
export * from "./fullscreen-layout.vue?vue&type=script&lang=js&"
import style0 from "./fullscreen-layout.vue?vue&type=style&index=0&id=70bb0732&scoped=true&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bb0732",
  null
  
)

export default component.exports